import axiosConn from '../axiosConn';

const headersFor = (jwt) => ({ headers: { Authorization: `Bearer ${jwt}` } });
export const pushSetupChanged = () =>
  Object.assign(new Error('Alerts changed on this device.'), {
    code: 'PUSH_STATUS_REQUIRED',
  });
export function snapshotPushSubscription(sub) {
  if (!sub) return null;
  const value = sub.toJSON ? sub.toJSON() : sub;
  return {
    endpoint: value.endpoint,
    keys: { p256dh: value.keys?.p256dh, auth: value.keys?.auth },
  };
}
export function samePushSubscription(sub, snapshot) {
  const value = snapshotPushSubscription(sub);
  return !!(
    value &&
    snapshot &&
    value.endpoint === snapshot.endpoint &&
    value.keys.p256dh === snapshot.keys.p256dh &&
    value.keys.auth === snapshot.keys.auth
  );
}
export function pushActionId() {
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
    '',
  );
}
const unwrap = (response) => {
  if (response?.data?.success !== true) throw pushSetupChanged();
  return response.data.data || {};
};
// The caller captures observation BEFORE the gesture and owns all browser/account
// continuations. There is deliberately no OBSERVE or automatic retry in this helper.
export async function registerWebPushAttempt({
  jwt,
  subscription,
  observationProof,
  bootstrap,
  actionId,
  wantsOptIn,
  isCurrent,
}) {
  if (!(await isCurrent())) return null;
  const claim = unwrap(
    await axiosConn.post(
      'notifications/webpush-claim',
      {
        ...subscription,
        actionId,
        ...(bootstrap ? { bootstrap: true } : { observationProof }),
      },
      headersFor(jwt),
    ),
  );
  if (!(await isCurrent())) return null;
  if (!claim.alreadyActive && !claim.claimProof) throw pushSetupChanged();
  if (claim.claimProof) {
    unwrap(
      await axiosConn.post(
        'notifications/register-webpush',
        {
          ...subscription,
          claimProof: claim.claimProof,
        },
        headersFor(jwt),
      ),
    );
    if (!(await isCurrent())) return null;
  }
  // Ownership and consent are separate. Reconnect never silently opts in.
  if (wantsOptIn) {
    unwrap(
      await axiosConn.post(
        'notifications/webpush-enable',
        {
          ...subscription,
          ...(claim.claimProof
            ? { claimProof: claim.claimProof }
            : { observationProof }),
        },
        headersFor(jwt),
      ),
    );
    if (!(await isCurrent())) return null;
  }
  return true;
}
